const ADYEN_CHECKOUT_ERROR_NAMES = [
  'NETWORK_ERROR',
  'CANCEL',
  'IMPLEMENTATION_ERROR',
  'API_ERROR',
  'ERROR',
  'SCRIPT_ERROR',
  'SDK_ERROR',
];

export const getIsAdyenCheckoutError = (error: Error): boolean =>
  ADYEN_CHECKOUT_ERROR_NAMES.includes(error.name);
